import env from './env';

export const CONFIG_CONSTANTS = {
    DEFAULT_LIMIT: 1000,
    API_HOST_PATH: env.REACT_APP_HOST_PATH,
    GOOGLE_GTAG_KEY: env.REACT_APP_G_TAG
}; 